// Overlapping company refetches: only the newest applies its result, and a year jump asked for by an
// overtaken call (the company switch) is carried into the call that does apply.
export const createRefetchGate = () => {
    let sequence = 0;
    let pendingSelectLatestYear = false;
    return {
        begin(selectLatestYear: boolean): number {
            sequence += 1;
            pendingSelectLatestYear ||= selectLatestYear;
            return sequence;
        },
        isCurrent(token: number): boolean {
            return token === sequence;
        },
        takeSelectLatestYear(): boolean {
            const value = pendingSelectLatestYear;
            pendingSelectLatestYear = false;
            return value;
        },
    };
};
